import { camelizeJson } from "utils/utils";
import API_URLS from "constants/apis.url";

import { getRequest, putRequest } from "./api";

export const fetchUserRole = async () => getRequest(API_URLS.userRoleURL, false);
export const updateLoginTime = () => putRequest(API_URLS.loginTimeURL, {}, true);

export const fetchSystemsAndAlarms = async () => {
  const response = await getRequest(API_URLS.landingPageURL, false);
  const { SystemsStatus, ActiveAlarms } = response.data;
  camelizeJson(SystemsStatus);
  camelizeJson(ActiveAlarms);
  const alarms = ActiveAlarms.map(alarm => {
    const { alarmId, timestamp, sysId, sysName } = alarm;
    alarm.id = alarmId + timestamp + sysId + sysName;
    return alarm;
  });
  return { systems: SystemsStatus, alarms };
};

export const fetchAnomalyList = async () => getRequest(API_URLS.anomalyURL, false, { params: { active: true } });
